module.exports = __webpack_public_path__ + "img/parq_delux3.efdb01d0.jpg";